import React from 'react';
import { TextField } from '@material-ui/core';
function isValidJSONString(str) {
    try {
        JSON.parse(str || '');
    }
    catch (e) {
        return false;
    }
    return true;
}
// eslint-disable-next-line @typescript-eslint/ban-types
export const EntityJsonField = props => {
    var _a, _b;
    const { plugin, column, value, onChange } = props;
    const error = (_b = (_a = plugin.edit) === null || _a === void 0 ? void 0 : _a.validateError) === null || _b === void 0 ? void 0 : _b.call(_a, column, value);
    function convertToJson(data) {
        const jsonData = isValidJSONString(data) ? JSON.parse(data) : data;
        return jsonData;
    }
    return (React.createElement(TextField, { fullWidth: true, multiline: true, size: 'small', variant: 'outlined', value: typeof value !== 'string' ? JSON.stringify(value) : value || undefined, error: !!error, inputProps: { style: { fontFamily: 'monospace' } }, label: 'Enter a JSON format text', helperText: error || '', onChange: event => {
            const value = event.target.value;
            onChange === null || onChange === void 0 ? void 0 : onChange(value ? convertToJson(value) : undefined);
        } }));
};
export const EntityJsonbPlugin = {
    type: 'jsonb',
    edit: {
        field: EntityJsonField,
        validateError: (column, value) => {
            return typeof value === 'string' ? 'Invalid Json Format.' : undefined;
        }
    }
};
//# sourceMappingURL=EntityJsonbPlugin.js.map